import React, { useState, useCallback, useRef, useEffect, ReactNode } from 'react';
import { ButtonProps } from './types';
import { useNewUiTheme } from '../newUiTheme';

export interface ButtonWithImageProps extends Omit<ButtonProps, 'text'> {
  image: ReactNode;
  text: string;
}

export function ButtonWithImage(props: ButtonWithImageProps) {
  const uiTheme = useNewUiTheme();

  const [loading, setLoading] = useState(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const onClick = useCallback(async () => {
    if (loading) {
      return;
    }

    if (props.onClick) {
      setLoading(true);

      try {
        await props.onClick();
        setLoading(false);
      } finally {
        if (mounted.current) {
          setLoading(false);
        }
      }
    }
  }, [loading, props.onClick]);

  return (
    <uiTheme.buttons.DefaultButtonLayout
      {...props}
      text={props.text}
      image={props.image}
      onClick={onClick}
      isLoading={loading}
      loadingText={props.loadingText}
      style={props.style}
    />
  );
}
